export enum SortColumnEnum {
    NewVersion,
    VesselName,
    SentToDNV,
    VerificationDate,
    PeriodStart,
    PeriodEnd,
    ReportType,
    NumberOfIssues,
    Status,
}